exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.h-60 {\n    height: 60px;\n}\n.el-radio-button__inner{\n    padding: 10px;\n}\n", ""]);

// exports
